import { Link } from 'react-router-dom'
import { Button } from '@square/ui'
import RouteHeader from './RouteHeader'

export default function NotFound() {
  return (
    <div style={{ maxWidth: 540 }}>
      <RouteHeader
        kicker="404"
        title="Not found"
        description="The route you tried to reach doesn't exist."
      />
      <Link to="/dashboard">
        <Button variant="secondary">Back to dashboard</Button>
      </Link>
    </div>
  )
}
